import SponsorshipProductsWrapper from "./ProductsWrapper";

export default SponsorshipProductsWrapper;
